import API from "./API";
import {
  DashboardStats,
  AnalyticsData,
  BookingsResponse,
  BookingDetails,
  BookingFilters,
} from "../../Types/Dashboard";

class DashboardService extends API {
  static getStats = (): Promise<{ data: DashboardStats }> => {
    return this.getRequest("admin/dashboard/stats", true) as unknown as Promise<{ data: DashboardStats }>;
  };

  static getAnalytics = (
    period: number = 30
  ): Promise<{ data: AnalyticsData }> => {
    return this.getRequest(`admin/dashboard/analytics?period=${period}`, true) as unknown as Promise<{ data: AnalyticsData }>;
  };

  static getBookings = (
    filters?: BookingFilters
  ): Promise<{ data: BookingsResponse }> => {
    const params = new URLSearchParams();
    if (filters?.page) params.append("page", filters.page.toString());
    if (filters?.per_page) params.append("per_page", filters.per_page.toString());
    if (filters?.status) params.append("status", filters.status);
    if (filters?.tutor_id) params.append("tutor_id", filters.tutor_id.toString());
    if (filters?.student_id)
      params.append("student_id", filters.student_id.toString());
    if (filters?.start_date) params.append("start_date", filters.start_date);
    if (filters?.end_date) params.append("end_date", filters.end_date);

    const queryString = params.toString();
    return this.getRequest(
      `admin/bookings${queryString ? `?${queryString}` : ""}`,
      true
    ) as unknown as Promise<{ data: BookingsResponse }>;
  };

  static getBookingDetails = (
    id: number
  ): Promise<{ data: { booking: BookingDetails } }> => {
    return this.getRequest(`admin/bookings/${id}`, true) as unknown as Promise<{ data: { booking: BookingDetails } }>;
  };

  static getUserBookings = (
    userId: number,
    filters?: { page?: number; per_page?: number; status?: string }
  ): Promise<{ data: BookingsResponse }> => {
    const params = new URLSearchParams();
    if (filters?.page) params.append("page", filters.page.toString());
    if (filters?.per_page) params.append("per_page", filters.per_page.toString());
    if (filters?.status) params.append("status", filters.status);

    const queryString = params.toString();
    return this.getRequest(
      `admin/users/${userId}/bookings${queryString ? `?${queryString}` : ""}`,
      true
    ) as unknown as Promise<{ data: BookingsResponse }>;
  };

  static getUserOrders = (
    userId: number,
    filters?: { page?: number; per_page?: number; status?: string }
  ): Promise<{ data: { orders: any[]; meta: any } }> => {
    const params = new URLSearchParams();
    if (filters?.page) params.append("page", filters.page.toString());
    if (filters?.per_page) params.append("per_page", filters.per_page.toString());
    if (filters?.status) params.append("status", filters.status);

    const queryString = params.toString();
    return this.getRequest(
      `admin/users/${userId}/orders${queryString ? `?${queryString}` : ""}`,
      true
    ) as unknown as Promise<{ data: { orders: any[]; meta: any } }>;
  };

  static getUserTransactions = (
    userId: number,
    filters?: { page?: number; per_page?: number }
  ): Promise<{ data: { transactions: any[]; meta: any } }> => {
    const params = new URLSearchParams();
    if (filters?.page) params.append("page", filters.page.toString());
    if (filters?.per_page) params.append("per_page", filters.per_page.toString());

    const queryString = params.toString();
    return this.getRequest(
      `admin/users/${userId}/transactions${queryString ? `?${queryString}` : ""}`,
      true
    ) as unknown as Promise<{ data: { transactions: any[]; meta: any } }>;
  };

  static getUserStats = (
    userId: number
  ): Promise<{ data: { bookings: any; orders: any; transactions: any; credits: any } }> => {
    return this.getRequest(`admin/users/${userId}/stats`, true) as unknown as Promise<{ data: { bookings: any; orders: any; transactions: any; credits: any } }>;
  };
}

export default DashboardService;
